import { gql } from '@apollo/client';

export const GET_QUIZ_BY_ID = gql`
  query GetQuizById($id: ID!) {
    getQuizById(id: $id) {
      id
      userId
      userQuestions {
        questionId
        question {
          id
          prompt
          explanation
          tag
          options {
            desc
            isAnswer
          }
        }
        selectedOption {
          desc
          isAnswer
        }
      }
      isCompleted
      completedAt
      tag
      createdAt
    }
  }
`;
